import { render } from "./EditPlatFormVideoCate.vue?vue&type=template&id=250cb921&scoped=true"
import script from "./EditPlatFormVideoCate.vue?vue&type=script&lang=js"
export * from "./EditPlatFormVideoCate.vue?vue&type=script&lang=js"

import "./EditPlatFormVideoCate.vue?vue&type=style&index=0&id=250cb921&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-250cb921"]])

export default __exports__